<div *ngIf="showTitle" class="content-title-container">
    <div class="header-left">
        <div class="header-title">
            Progress
        </div>
    </div>
</div>

<div class="circle-summary">
    <app-progress-circle class="chart" progressTitle="Project Summary" [value]="averageTaskProgress" [totalCount]="totalCount"></app-progress-circle>
    <app-progress-circle
        class="chart"
        progressTitle="Test Case Summary"
        [value]="testCaseProgress"
        [totalCount]="testCaseCount"
        [isTestCase]="true"
        [projectId]="info.projectId"
        [projectGroupId]="info.projectGroupId"
        [currentUser]="currentUser"
    ></app-progress-circle>
    <app-progress-circle class="chart" progressTitle="Document Review" [value]="averageDocumentReviewTaskProgress" [totalCount]="documentReviewedCount"></app-progress-circle>
    <app-progress-circle class="chart" progressTitle="General Task" [value]="averageOtherTaskProgress" [totalCount]="otherTaskCount"></app-progress-circle>
</div>
